import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthState } from 'react-redux-django-auth';
import { ROLES, DASHBOARD_ROUTES, RoleType } from '../../constants/roles';

export const DashboardRedirect: React.FC = () => {
  const { user, isAuthenticated, isAuthLoading } = useAuthState();
  const location = useLocation();

  if (isAuthLoading) {
    return (
      <div className="cht-min-h-screen cht-flex cht-items-center cht-justify-center cht-bg-slate-50">
        <div className="cht-flex cht-flex-col cht-items-center cht-gap-3">
          <div className="cht-w-10 cht-h-10 cht-border-4 cht-border-[#3e57da] cht-border-t-transparent cht-rounded-full cht-animate-spin" />
          <p className="cht-text-xs cht-font-black cht-text-gray-400 cht-uppercase cht-tracking-widest">
            Routing to Dashboard...
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to={`/login?ReturnUrl=${encodeURIComponent(location.pathname)}`} replace />;
  }

  const userRoles: RoleType[] = (
    Array.isArray(user.roles) && user.roles.length > 0
      ? user.roles
      : [user.role || (user.is_superuser ? ROLES.SUPERADMIN : user.is_staff ? ROLES.ADMIN : ROLES.STUDENT)]
  ) as RoleType[];

  let targetRole: RoleType = ROLES.STUDENT;
  if (user.is_superuser || userRoles.includes(ROLES.SUPERADMIN)) {
    targetRole = ROLES.SUPERADMIN;
  } else if (userRoles.includes(ROLES.ADMIN)) {
    targetRole = ROLES.ADMIN;
  } else if (userRoles.includes(ROLES.INSTRUCTOR)) {
    targetRole = ROLES.INSTRUCTOR;
  } else {
    targetRole = user.role || userRoles[0] || ROLES.STUDENT;
  }

  const targetPath = DASHBOARD_ROUTES[targetRole] || '/student/dashboard';
  return <Navigate to={targetPath} replace />;
};

export default DashboardRedirect;
